module.exports = __webpack_public_path__ + "static/img/10.04dcebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/10.png
// module id = qrNx
// module chunks = 4